/* Fase de venta de la landing (desde el lanzamiento; clase wbl-sale en <html>, la pone «WBL · Cabecera").
   El bloque «Comprar» del diseño ya lleva el estado (color elegido, correas extra 0–3 por color y el total) con su
   propio script; aquí sólo se engancha la compra de verdad:
     · «Comprar ahora»   → checkout directo con un enlace de carrito (/cart/ID:CANTIDAD,…)
     · «Añadir a la cesta» → /cart/add.js y al carrito
   Variantes reales por color (handle de la opción) desde #wbl-buy-config. Colores y correas sin stock: «Agotado» y no
   se pueden elegir. */
(() => {
  if (!document.documentElement.classList.contains('wbl-sale')) return;
  const cfgEl = document.getElementById('wbl-buy-config');
  const sec = document.getElementById('comprar');
  if (!cfgEl || !sec) return;
  const cfg = JSON.parse(cfgEl.textContent);
  const $ = (s, c = sec) => c.querySelector(s);
  const $$ = (s, c = sec) => [...c.querySelectorAll(s)];
  const toast = msg => {
    const t = document.getElementById('toast'), x = document.getElementById('toastTxt');
    if (!t || !x) return;
    x.textContent = msg; t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 3200);
  };

  /* ---------- Agotados ---------- */
  const soldOut = v => !v || !v.available;
  $$('.swatch').forEach(sw => {
    if (!soldOut(cfg.band[sw.dataset.color])) return;
    sw.classList.add('is-soldout');
    sw.setAttribute('aria-disabled', 'true');
    sw.title = `${sw.title} · ${cfg.soldout}`;
  });
  // Antes que el script del diseño (fase de captura): un color agotado no se puede elegir.
  sec.addEventListener('click', e => {
    if (e.target.closest('.swatch.is-soldout')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  $$('.buy__extras li').forEach(li => {
    if (!soldOut(cfg.strap[li.dataset.color])) return;
    li.classList.add('is-soldout');
    li.dataset.soldout = cfg.soldout;
    li.title = `${li.title} · ${cfg.soldout}`;
  });
  // Si el color de partida está agotado, se elige el primero que no lo esté (con el clic del propio diseño).
  const on = $('.swatch.on');
  if (on && on.classList.contains('is-soldout')) {
    const first = $$('.swatch').find(s => !s.classList.contains('is-soldout'));
    if (first) first.click();
  }

  /* ---------- Compra ---------- */
  const items = () => {
    const band = cfg.band[($('.swatch.on') || {}).dataset?.color];
    if (soldOut(band)) return null;
    const list = [{ id: band.id, quantity: 1 }];
    $$('.buy__extras li').forEach(li => {
      const q = parseInt(($('.stepper b', li) || {}).textContent || '0', 10);
      const v = cfg.strap[li.dataset.color];
      if (q > 0 && !soldOut(v)) list.push({ id: v.id, quantity: q });
    });
    return list;
  };

  $$('[data-wbl-buy]').forEach(btn => btn.addEventListener('click', async () => {
    const list = items();
    if (!list) { toast(cfg.soldout); return; }
    if (btn.dataset.wblBuy === 'checkout') {
      location.href = `${cfg.cartUrl.replace(/\/$/, '')}/${list.map(i => `${i.id}:${i.quantity}`).join(',')}`;
      return;
    }
    btn.disabled = true;
    try {
      const r = await fetch(`${cfg.cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list }),
      });
      if (!r.ok) throw new Error(`cart/add ${r.status}`);
      location.href = cfg.cartUrl;
    } catch (e) {
      btn.disabled = false;
      toast(cfg.error);
    }
  }));
})();
